export function formatCardNumber(card: string | null | undefined): string {
  if (!card) return '-';

  return card
    .replace(/\D/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim();
}

export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '-';

  return phone
    .replace(/\D/g, '')
    .replace(/(\d{1,3})(?=(\d{3})+(?!\d))/g, '$1 ')
    .trim();
}
